import MarkdownIt from "markdown-it";
import { RuleInline } from "markdown-it/lib/parser_inline.mjs";

const underlineRule: RuleInline = (state, silent) => {
  const startPos = state.pos;

  // Look for two underscores
  if ((state.src as string).slice(startPos, startPos + 3) === "<u>") {
    if (!silent) {
      state.push("underline_open", "u", 1); // opening <u> tag
    }
    state.pos = startPos + 3;
    return true;
  }
  if ((state.src as string).slice(startPos, startPos + 4) === "</u>") {
    if (!silent) {
      state.push("underline_close", "u", -1); // opening <u> tag
    }
    state.pos = startPos + 4;
    return true;
  }
  return false;
};

export default function markdownItUnderline(md: MarkdownIt) {
  // Custom rule to handle underline syntax with double underscores __text__

  // Register the underline rule at the beginning of inline rules
  md.inline.ruler.push("underline", underlineRule);
}
